import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import RightSquareTwoToneSvg from "@ant-design/icons-svg/es/asn/RightSquareTwoTone";
import AntdIcon from "../components/AntdIcon";
var RightSquareTwoTone = function RightSquareTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RightSquareTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  RightSquareTwoTone.displayName = 'RightSquareTwoTone';
}
export default /*#__PURE__*/React.forwardRef(RightSquareTwoTone);